import { makeStyles } from "@material-ui/core/styles";

const useEnterpriseThankYouModalStyles = makeStyles(() => ({
  modalWrapper: {
    position: "relative",
    width: "500px",
    height: "180px",
    backgroundColor: "#1B1D28",
    boxShadow: "0px 19px 45px rgba(0, 0, 0, 0.12)",
    borderRadius: "20px",
    padding: "24px 24px 48px",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    color: "#F9F9F9",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: "16px",
  },

  titleWrapper: {
    display: "flex",
    justifyContent: "center",
    flexGrow: 1,
  },

  title: {
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "24px",
    lineHeight: "36px",
  },

  messageWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },

  message: {
    fontFamily: "Poppins",
    fontSize: "13px",
    lineHeight: "20px",
    color: "#B1B5C9",
  },
}));

export default useEnterpriseThankYouModalStyles;
